export default "__VITE_ASSET__Cua8UdJy__"